var addToCartPopup = class extends HTMLElement {
    addToCartTrigger = this.querySelector('#addToCartTrigger');
    sizesContainer = document.querySelector('.sizes-container');
    sizeElements = document.querySelectorAll('[data-submit-mobile]');
    isMobile = window.innerWidth <= 999;
    closeBtn = this.sizesContainer.querySelector('.close-btn');
    overlay = this.sizesContainer.querySelector('.popup-overlay');
    connectedCallback() {
        // Add an event listener and call the 'open' method from the parent class
        this.addToCartTrigger.addEventListener("click", (event) => {
            this.open()  // Calls the 'open' method from OpenableElement (the parent class)
        });
        this.sizeElements.forEach(sizeElement => {
            sizeElement.addEventListener('click', (event) => {
                this.addToCart(event)
            })
        })
        this.closeBtn.addEventListener('click', () =>  this.close())
        this.overlay.addEventListener('click', () =>  this.close())
    }

    open() {
        this.sizesContainer.classList.remove('hidden-pocket')
    }

    close() {
        this.sizesContainer.classList.add('hidden-pocket')
        document.querySelector('popover-content.product-added').open = false;
        document.querySelector('.product-added .animated-border').classList.remove('animation-started')

    }

    addToCart(event) {
        event.preventDefault();



        if (this.isMobile) {
            const target = event.currentTarget
            const form = document.querySelector('.shopify-add-to-cart');
            const variantId = form.querySelector('input[name="id"]').value;
            const handle = form.querySelector('input[name="product-handle"]').value;

            if (target.classList.contains('block-swatch__item--out-of-stock')){
                this.openCreateAler()
            } else {
                addToCart({ 'id': variantId, 'quantity': 1 }, true, true, false);
                this.openModalAddedToCart(event, variantId, handle)
                // this.setLoading(target, true)
                setTimeout(() => {
                    this.close()
                }, 6000)

            }
        }
    }

    openCreateAler() {
        // Show an alert to the user that the item is out of stock
    }

    openModalAddedToCart(event, variantId, handle) {
        event.preventDefault();
        document.querySelector('.product-added .animated-border').classList.add('animation-started')
        // Construct the URL with variant ID and view as query parameters
        const modalUrl = `/products/${handle}?variant=${variantId}&view=added-to-cart`;

        this.getItemHtml(handle, variantId)
            .then((html) => {
                const modalContent = document.querySelector('.popup__added-content');
                const productContent = new DOMParser().parseFromString(html, 'text/html').querySelector('.added-to-cart');

                modalContent.innerHTML = productContent.innerHTML;
            })
            .catch((err) => {
                console.error('Failed to fetch product HTML:', err);
            });
    }

    getItemHtml(handle, variant, view = 'added-to-cart') {
        if (!handle) {
            return Promise.reject('No handle provided');
        }

        const base = Shopify.routes.root || '';
        const params = `products/${handle}?&view=${view}`;
        let variantString = '';
        if (variant) {
            variantString = `&variant=${variant}`;
        }
        const url = `${base}${params}${variantString}`;

        return fetch(url)
            .then(function (response) {
                return response.text();
            })
            .catch(function (err) {
                console.error('Something went wrong.', err);
            });
    }

    setLoading(el, state) {
        const loadingElement = el.querySelector('.loader');
        if (state) {
            loadingElement.classList.remove('visually-hidden');
        } else {
            loadingElement.classList.add('visually-hidden');
        }
    }
}
window.customElements.define("add-to-cart-mobile", addToCartPopup);
